/**
 * OSAKASTUDIO SHOPIFY ONLINE STORE 2.0 THEME ENGINE
 * -----------------------------------------------------------------------------
 * Integrates Shopify Liquid JSON data bridge, Shopify Ajax Cart API (/cart.js),
 * dynamic multi-option variant handling, app block slots, and modular game engine.
 */

// STATE
let PRODUCTS = [];
let isZoomedOut = true;
let stockFilter = 'all';
let sortFilter = 'default';
let categoryFilter = 'all';
let sizeFilter = 'all';

// ZOOM MODAL STATE
let currentZoomProduct = null;
let currentZoomImgIdx = 0;

// INITIALIZE ON DOM LOAD
document.addEventListener('DOMContentLoaded', () => {
  initProductCatalogData();
  initCartApi();
  initEventListeners();
  renderCatalog();
  fetchShopifyCart();
});

/**
 * 1. PRODUCT DATA BRIDGE
 * Parses real Liquid product data rendered into #product-catalog-data script tag.
 */
function initProductCatalogData() {
  const dataEl = document.getElementById('product-catalog-data');
  if (dataEl) {
    try {
      PRODUCTS = JSON.parse(dataEl.textContent);
      // Initialize current image index state for each product
      PRODUCTS.forEach(p => {
        p.currentImgIndex = 0;
      });
    } catch (err) {
      console.error('Error parsing Shopify product catalog data:', err);
      PRODUCTS = [];
    }
  }
}

/**
 * 2. SHOPIFY AJAX CART API INTEGRATION
 * Handles /cart.js, /cart/add.js, and /cart/change.js endpoints for real order processing.
 */
function fetchShopifyCart() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      updateCartDrawerUI(cart);
    })
    .catch(err => console.error('Error fetching Shopify cart:', err));
}

function addToShopifyCart(variantId, quantity = 1, properties = {}) {
  const cartItemsList = document.getElementById('cartItemsList');
  if (cartItemsList) cartItemsList.classList.add('cart-loading-state');

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: quantity, properties: properties })
  })
  .then(res => res.json())
  .then(data => {
    if (cartItemsList) cartItemsList.classList.remove('cart-loading-state');
    if (data.status && data.status !== 200) {
      alert(data.description || 'Could not add item to cart.');
      return;
    }
    fetchShopifyCart();
    document.getElementById('productDrawer').classList.remove('active');
    document.getElementById('cartDrawer').classList.add('active');
  })
  .catch(err => {
    if (cartItemsList) cartItemsList.classList.remove('cart-loading-state');
    console.error('Error adding to Shopify cart:', err);
    alert('Error adding item to cart.');
  });
}

function changeShopifyCartQuantity(lineKey, quantity) {
  const cartItemsList = document.getElementById('cartItemsList');
  if (cartItemsList) cartItemsList.classList.add('cart-loading-state');

  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: lineKey, quantity: quantity })
  })
  .then(res => res.json())
  .then(cart => {
    if (cartItemsList) cartItemsList.classList.remove('cart-loading-state');
    updateCartDrawerUI(cart);
  })
  .catch(err => {
    if (cartItemsList) cartItemsList.classList.remove('cart-loading-state');
    console.error('Error updating Shopify cart:', err);
  });
}

function updateCartDrawerUI(cart) {
  const cartCount = document.getElementById('cartCount');
  const drawerCartCount = document.getElementById('drawerCartCount');
  const cartDrawerCount = document.getElementById('cartDrawerCount');
  const cartSubtotal = document.getElementById('cartSubtotal');
  const cartItemsList = document.getElementById('cartItemsList');

  if (cartCount) cartCount.textContent = cart.item_count;
  if (drawerCartCount) drawerCartCount.textContent = cart.item_count;
  if (cartDrawerCount) cartDrawerCount.textContent = cart.item_count;

  // Format currency from cents
  const formattedSubtotal = (cart.total_price / 100).toLocaleString('en-US', { style: 'currency', currency: cart.currency || 'USD' });
  if (cartSubtotal) cartSubtotal.textContent = formattedSubtotal;

  if (!cartItemsList) return;

  if (cart.items.length === 0) {
    cartItemsList.innerHTML = `<div style="text-align:center; padding: 40px 0; color: var(--text-muted); font-size: 10px;">STASH BAG IS EMPTY</div>`;
    return;
  }

  cartItemsList.innerHTML = '';
  cart.items.forEach(item => {
    const row = document.createElement('div');
    row.className = 'cart-item-row';
    
    let variantMeta = item.variant_title && item.variant_title !== 'Default Title' ? `SIZE / VARIANT: ${item.variant_title}` : '';
    let propsMeta = '';
    if (item.properties && Object.keys(item.properties).length > 0) {
      propsMeta = Object.entries(item.properties).map(([k, v]) => `${k}: ${v}`).join(' | ');
    }
    const combinedMeta = [variantMeta, propsMeta].filter(Boolean).join(' | ');

    const lineTotalFormatted = (item.final_line_price / 100).toLocaleString('en-US', { style: 'currency', currency: cart.currency || 'USD' });

    row.innerHTML = `
      <img src="${item.image || ''}" alt="${item.title}" class="cart-item-img" />
      <div class="cart-item-details">
        <div>
          <div class="cart-item-title">${item.product_title || item.title}</div>
          <div class="cart-item-meta">${combinedMeta}</div>
          <div class="cart-item-title" style="margin-top: 4px;">${lineTotalFormatted}</div>
        </div>
        <div class="qty-control">
          <button class="qty-btn dec-btn" data-key="${item.key}" data-qty="${item.quantity - 1}">-</button>
          <span>${item.quantity}</span>
          <button class="qty-btn inc-btn" data-key="${item.key}" data-qty="${item.quantity + 1}">+</button>
        </div>
      </div>
    `;

    row.querySelector('.dec-btn').addEventListener('click', () => {
      changeShopifyCartQuantity(item.key, item.quantity - 1);
    });

    row.querySelector('.inc-btn').addEventListener('click', () => {
      changeShopifyCartQuantity(item.key, item.quantity + 1);
    });

    cartItemsList.appendChild(row);
  });
}

function initCartApi() {
  const checkoutBtn = document.getElementById('checkoutBtn');
  const termsAgreeCheck = document.getElementById('termsAgreeCheck');
  const cartCheckoutForm = document.getElementById('cartCheckoutForm');

  if (checkoutBtn && cartCheckoutForm) {
    cartCheckoutForm.addEventListener('submit', (e) => {
      if (termsAgreeCheck && !termsAgreeCheck.checked) {
        e.preventDefault();
        alert('PLEASE AGREE TO THE FINAL SALE TERMS BEFORE CHECKOUT.');
      }
    });
  }
}

/**
 * 3. CATALOG RENDERING & FILTERING ENGINE
 */
function renderCatalog() {
  const catalogGrid = document.getElementById('catalogGrid');
  if (!catalogGrid) return;

  let list = [...PRODUCTS];

  if (categoryFilter !== 'all') {
    list = list.filter(p => {
      const pCat = (p.type || '').toLowerCase();
      const pTags = (p.tags || []).map(t => t.toLowerCase());
      const pCols = (p.collections || []).map(c => c.toLowerCase());
      const filterCat = categoryFilter.toLowerCase();
      return pCat === filterCat || pTags.includes(filterCat) || pCols.includes(filterCat) || p.handle.includes(filterCat);
    });
  }

  if (sizeFilter !== 'all') {
    list = list.filter(p => {
      if (!p.variants || p.variants.length === 0) return false;
      return p.variants.some(v => v.options.includes(sizeFilter) && v.available);
    });
  }

  if (stockFilter === 'in-stock') {
    list = list.filter(p => p.available);
  }

  if (sortFilter === 'low-high') {
    list.sort((a, b) => a.price - b.price);
  } else if (sortFilter === 'high-low') {
    list.sort((a, b) => b.price - a.price);
  }

  catalogGrid.className = `catalog-grid ${isZoomedOut ? 'cols-8' : 'cols-4'}`;
  catalogGrid.innerHTML = '';

  if (list.length === 0) {
    catalogGrid.innerHTML = `
      <div style="grid-column: 1 / -1; text-align: center; padding: 60px 0; font-size: 11px; color: var(--text-muted);">
        NO PRODUCTS MATCH YOUR SELECTION. <button id="clearFilterLink" style="text-decoration: underline; font-weight: 700;">RESET FILTERS</button>
      </div>
    `;
    const clearLink = document.getElementById('clearFilterLink');
    if (clearLink) clearLink.addEventListener('click', resetFilters);
    return;
  }

  list.forEach((product, idx) => {
    const item = document.createElement('div');
    item.className = `product-item ${!product.available ? 'is-sold-out' : ''}`;
    item.style.setProperty('--item-idx', idx);
    item.setAttribute('data-id', product.id);
    item.setAttribute('data-handle', product.handle);

    let variantsHTML = '';
    if (!product.available) {
      variantsHTML = `<span class="sold-out-text">SOLD OUT</span>`;
    } else if (product.options && product.options.length > 0 && product.options[0].values.length > 1) {
      const primaryOption = product.options[0];
      variantsHTML = primaryOption.values.map(val => {
        const hasAvailable = product.variants.some(v => v.options.includes(val) && v.available);
        return `<span class="size-tag ${hasAvailable ? '' : 'disabled'}" data-size="${val}">${val}</span>`;
      }).join(' ');
    } else {
      variantsHTML = `<button class="quick-plus-btn" data-add="true">+</button>`;
    }

    const currentImg = product.images[product.currentImgIndex || 0] || '';
    const dotsHTML = product.images.length > 1 ? product.images.map((_, i) => 
      `<span class="carousel-dot ${i === (product.currentImgIndex || 0) ? 'active' : ''}"></span>`
    ).join('') : '';

    const navBtnsHTML = product.images.length > 1 ? `
      <button class="img-nav-btn prev-img-btn" aria-label="Previous Image">&lt;</button>
      <button class="img-nav-btn next-img-btn" aria-label="Next Image">&gt;</button>
    ` : '';

    item.innerHTML = `
      <div class="product-img-container">
        ${navBtnsHTML}
        <img src="${currentImg}" alt="${product.title}" loading="lazy" class="product-main-img" />
        <div class="carousel-dots">${dotsHTML}</div>
      </div>
      <div class="product-title">${product.title}</div>
      <div class="product-price">${product.priceFormatted || '$' + product.price.toFixed(2)}</div>
      <div class="product-variants-row">
        ${variantsHTML}
      </div>
    `;

    const prevBtn = item.querySelector('.prev-img-btn');
    const nextBtn = item.querySelector('.next-img-btn');

    if (prevBtn) {
      prevBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        const nextIdx = (product.currentImgIndex - 1 + product.images.length) % product.images.length;
        changeCardImage(item, product, nextIdx, 'prev');
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        const nextIdx = (product.currentImgIndex + 1) % product.images.length;
        changeCardImage(item, product, nextIdx, 'next');
      });
    }

    // TOUCH SWIPE FOR CATALOG CARDS ON MOBILE VIEW
    const cardImgContainer = item.querySelector('.product-img-container');
    if (cardImgContainer && product.images.length > 1) {
      let cardTouchStartX = 0;
      let cardTouchStartY = 0;
      cardImgContainer.addEventListener('touchstart', (e) => {
        cardTouchStartX = e.changedTouches[0].screenX;
        cardTouchStartY = e.changedTouches[0].screenY;
      }, { passive: true });

      cardImgContainer.addEventListener('touchend', (e) => {
        const cardTouchEndX = e.changedTouches[0].screenX;
        const cardTouchEndY = e.changedTouches[0].screenY;
        const diffX = cardTouchEndX - cardTouchStartX;
        const diffY = cardTouchEndY - cardTouchStartY;

        if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 30) {
          const nextIdx = diffX < 0 
            ? (product.currentImgIndex + 1) % product.images.length 
            : (product.currentImgIndex - 1 + product.images.length) % product.images.length;
          changeCardImage(item, product, nextIdx, diffX < 0 ? 'next' : 'prev');
        }
      }, { passive: true });
    }

    item.addEventListener('click', (e) => {
      const sizeTag = e.target.closest('.size-tag');
      const plusBtn = e.target.closest('.quick-plus-btn');

      if (sizeTag) {
        e.stopPropagation();
        const selectedVal = sizeTag.getAttribute('data-size');
        openProductDrawer(product, selectedVal);
      } else if (plusBtn) {
        e.stopPropagation();
        openProductDrawer(product);
      } else {
        openProductDrawer(product);
      }
    });

    catalogGrid.appendChild(item);
  });
}

function changeCardImage(itemElement, product, newIndex, direction = 'next') {
  product.currentImgIndex = newIndex;

  const imgEl = itemElement.querySelector('.product-main-img');
  const dots = itemElement.querySelectorAll('.carousel-dot');
  const titleEl = itemElement.querySelector('.product-title');
  const priceEl = itemElement.querySelector('.product-price');

  if (imgEl) {
    imgEl.src = product.images[newIndex];
    imgEl.classList.remove('carousel-slide-next', 'carousel-slide-prev');
    void imgEl.offsetWidth;
    imgEl.classList.add(direction === 'next' ? 'carousel-slide-next' : 'carousel-slide-prev');
  }

  if (titleEl) {
    titleEl.classList.remove('product-text-anim');
    void titleEl.offsetWidth;
    titleEl.classList.add('product-text-anim');
  }

  if (priceEl) {
    priceEl.classList.remove('product-text-anim');
    void priceEl.offsetWidth;
    priceEl.classList.add('product-text-anim');
  }

  dots.forEach((dot, i) => {
    if (i === newIndex) dot.classList.add('active');
    else dot.classList.remove('active');
  });
}

/**
 * 4. DYNAMIC MULTI-OPTION PRODUCT DETAIL DRAWER (PDP)
 */
function openProductDrawer(product, initialSelectedVal = null) {
  const productDrawer = document.getElementById('productDrawer');
  const productDetailBody = document.getElementById('productDetailBody');
  if (!productDrawer || !productDetailBody) return;

  let detailImgIdx = product.currentImgIndex || 0;
  let isDetailsOpen = false;

  // Selected options map: { "Size": "M", "Color": "Black" }
  let selectedOptions = {};
  if (product.options && product.options.length > 0) {
    product.options.forEach(opt => {
      if (initialSelectedVal && opt.values.includes(initialSelectedVal)) {
        selectedOptions[opt.name] = initialSelectedVal;
      } else {
        selectedOptions[opt.name] = opt.values[0];
      }
    });
  }

  function getSelectedVariant() {
    if (!product.variants || product.variants.length === 0) return null;
    return product.variants.find(v => {
      return product.options.every((opt, idx) => v.options[idx] === selectedOptions[opt.name]);
    }) || product.variants[0];
  }

  function renderPDP() {
    const selectedVariant = getSelectedVariant();
    const isVariantAvailable = selectedVariant ? selectedVariant.available : product.available;
    const currentPriceFormatted = selectedVariant ? selectedVariant.priceFormatted : (product.priceFormatted || '$' + product.price.toFixed(2));

    // Dynamic Options HTML
    let optionsSectionHTML = '';
    if (product.options && product.options.length > 0) {
      optionsSectionHTML = product.options.map(opt => {
        const optNameLower = opt.name.toLowerCase();
        const isColorOption = optNameLower.includes('color') || optNameLower.includes('colour');

        if (isColorOption) {
          return `
            <div class="pdp-colors-section">
              <div class="pdp-color-label">${opt.name.toUpperCase()}: <span id="pdpSelectedColorName">${selectedOptions[opt.name]}</span></div>
              <div class="pdp-colors-row">
                ${opt.values.map(val => {
                  const isActive = selectedOptions[opt.name] === val;
                  // Map color names to hex codes or fallback
                  const colorHexMap = { 'black': '#18181b', 'white': '#f8fafc', 'blue': '#2563eb', 'red': '#dc2626', 'grey': '#9ca3af', 'olive': '#65a30d', 'pink': '#ec4899' };
                  const bgHex = colorHexMap[val.toLowerCase()] || '#4b5563';
                  return `<button class="pdp-color-swatch ${isActive ? 'active' : ''}" style="background-color: ${bgHex};" data-option-name="${opt.name}" data-option-val="${val}" aria-label="${val}"></button>`;
                }).join('')}
              </div>
            </div>
          `;
        } else {
          return `
            <div class="pdp-sizes-row">
              ${opt.values.map(val => {
                const isActive = selectedOptions[opt.name] === val;
                // Check if this option value is available in any variant
                const valAvailable = product.variants.some(v => v.options.includes(val) && v.available);
                return `
                  <button class="pdp-size-btn ${isActive ? 'active' : ''} ${valAvailable ? '' : 'disabled'}" data-option-name="${opt.name}" data-option-val="${val}">
                    ${val}
                  </button>
                `;
              }).join('')}
            </div>
          `;
        }
      }).join('');
    }

    const currentImg = (product.images && product.images[detailImgIdx]) ? product.images[detailImgIdx] : '';

    const dotsHTML = (product.images && product.images.length > 1) ? product.images.map((_, i) => 
      `<span class="pdp-dot ${i === detailImgIdx ? 'active' : ''}"></span>`
    ).join('') : '';

    const pdpNavBtnsHTML = (product.images && product.images.length > 1) ? `
      <button class="img-nav-btn prev-img-btn" id="pdpPrevImg" aria-label="Previous Image">&lt;</button>
      <button class="img-nav-btn next-img-btn" id="pdpNextImg" aria-label="Next Image">&gt;</button>
    ` : '';

    const recProducts = PRODUCTS.filter(p => p.id !== product.id).slice(0, 4);
    const recsHTML = recProducts.map(rp => `
      <div class="product-item ${!rp.available ? 'is-sold-out' : ''}" data-id="${rp.id}" data-handle="${rp.handle}">
        <div class="product-img-container">
          <img src="${rp.images[0] || ''}" alt="${rp.title}" />
        </div>
        <div class="product-title">${rp.title}</div>
        <div class="product-price">${rp.priceFormatted || '$' + rp.price.toFixed(2)}</div>
      </div>
    `).join('');

    // Preserve App Block Container Slot
    const existingAppSlot = document.getElementById('shopifyAppBlockSlot');
    const appSlotHTML = existingAppSlot ? existingAppSlot.outerHTML : '<div class="shopify-app-block-slot" id="shopifyAppBlockSlot"></div>';

    productDetailBody.innerHTML = `
      <div class="pdp-hero-container">
        <div class="pdp-main-img-box" id="pdpImgBox">
          ${pdpNavBtnsHTML}
          <img src="${currentImg}" alt="${product.title}" id="pdpMainImg" />
        </div>
        <div class="pdp-carousel-dots">${dotsHTML}</div>
      </div>

      <div class="pdp-title">${product.title}</div>
      <div class="pdp-price" id="pdpPrice">${currentPriceFormatted}</div>

      ${optionsSectionHTML}

      <button class="pdp-add-btn" id="pdpAddBtn" ${!isVariantAvailable ? 'disabled style="opacity:0.5;"' : ''}>
        ${!isVariantAvailable ? 'SOLD OUT' : 'ADD TO STASH'}
      </button>

      <div class="pdp-details-link" id="pdpDetailsToggle">DETAILS</div>
      <div id="pdpDetailsContent" style="display: ${isDetailsOpen ? 'block' : 'none'}; text-align: center; max-width: 320px; font-size: 11px; color: var(--text-muted); margin-bottom: 30px; line-height: 1.5;">
        ${product.description || 'FOR THOSE WHO WANT MORE. OSAKA OFFICIAL PRODUCT.'}
      </div>

      ${appSlotHTML}

      <div class="pdp-recommendations-section">
        <div class="pdp-recommendations-grid">
          ${recsHTML}
        </div>
      </div>
    `;

    // NAV ARROWS LISTENERS
    const pdpPrevImg = productDetailBody.querySelector('#pdpPrevImg');
    const pdpNextImg = productDetailBody.querySelector('#pdpNextImg');

    if (pdpPrevImg) {
      pdpPrevImg.addEventListener('click', (e) => {
        e.stopPropagation();
        detailImgIdx = (detailImgIdx - 1 + product.images.length) % product.images.length;
        renderPDP();
      });
    }

    if (pdpNextImg) {
      pdpNextImg.addEventListener('click', (e) => {
        e.stopPropagation();
        detailImgIdx = (detailImgIdx + 1) % product.images.length;
        renderPDP();
      });
    }

    // ZOOM CLICK
    const pdpMainImg = productDetailBody.querySelector('#pdpMainImg');
    if (pdpMainImg) {
      pdpMainImg.addEventListener('click', () => openZoomModal(product, detailImgIdx));
    }

    // TOUCH SWIPE GESTURES FOR MOBILE VIEW ON PDP HERO IMAGE
    const pdpImgBox = productDetailBody.querySelector('#pdpImgBox');
    if (pdpImgBox && product.images && product.images.length > 1) {
      let touchStartX = 0;
      let touchStartY = 0;
      pdpImgBox.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
        touchStartY = e.changedTouches[0].screenY;
      }, { passive: true });

      pdpImgBox.addEventListener('touchend', (e) => {
        const touchEndX = e.changedTouches[0].screenX;
        const touchEndY = e.changedTouches[0].screenY;
        const diffX = touchEndX - touchStartX;
        const diffY = touchEndY - touchStartY;

        if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 35) {
          if (diffX < 0) {
            // Swiped left -> next image
            detailImgIdx = (detailImgIdx + 1) % product.images.length;
            renderPDP();
          } else {
            // Swiped right -> previous image
            detailImgIdx = (detailImgIdx - 1 + product.images.length) % product.images.length;
            renderPDP();
          }
        }
      }, { passive: true });
    }

    // CAROUSEL DOTS
    const pdpDots = productDetailBody.querySelectorAll('.pdp-dot');
    pdpDots.forEach((dot, idx) => {
      dot.addEventListener('click', () => {
        detailImgIdx = idx;
        renderPDP();
      });
    });

    // OPTION VALUE & COLOR SWATCH CLICKS
    const optionBtns = productDetailBody.querySelectorAll('[data-option-name]');
    optionBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const optName = btn.getAttribute('data-option-name');
        const optVal = btn.getAttribute('data-option-val');
        selectedOptions[optName] = optVal;

        // Check if selected variant has a specific image assigned
        const newVariant = getSelectedVariant();
        if (newVariant && newVariant.imageIndex !== undefined && product.images[newVariant.imageIndex]) {
          detailImgIdx = newVariant.imageIndex;
        }

        renderPDP();
      });
    });

    // DETAILS TOGGLE
    const toggleDetails = productDetailBody.querySelector('#pdpDetailsToggle');
    const contentDetails = productDetailBody.querySelector('#pdpDetailsContent');
    if (toggleDetails) {
      toggleDetails.addEventListener('click', () => {
        isDetailsOpen = !isDetailsOpen;
        contentDetails.style.display = isDetailsOpen ? 'block' : 'none';
      });
    }

    // ADD TO CART VIA SHOPIFY AJAX API
    const addBtn = productDetailBody.querySelector('#pdpAddBtn');
    if (addBtn && isVariantAvailable) {
      addBtn.addEventListener('click', () => {
        const targetVariant = getSelectedVariant();
        if (targetVariant) {
          addToShopifyCart(targetVariant.id, 1, selectedOptions);
        }
      });
    }

    // RECOMMENDATIONS CLICK
    const recItems = productDetailBody.querySelectorAll('.pdp-recommendations-grid .product-item');
    recItems.forEach(recEl => {
      recEl.addEventListener('click', () => {
        const rpId = recEl.getAttribute('data-id');
        const rpProduct = PRODUCTS.find(p => String(p.id) === String(rpId));
        if (rpProduct) openProductDrawer(rpProduct);
      });
    });
  }

  renderPDP();
  productDrawer.classList.add('active');
}

/**
 * 5. GLOBAL EVENT LISTENERS & FILTER CONTROLS
 */
function initEventListeners() {
  const themeToggleBtn = document.getElementById('themeToggleBtn');
  const viewToggleBtn = document.getElementById('viewToggleBtn');
  const filterToggleBtn = document.getElementById('filterToggleBtn');
  const closeFilterBtn = document.getElementById('closeFilterBtn');
  const applyFilterBtn = document.getElementById('applyFilterBtn');
  const resetFilterBtn = document.getElementById('resetFilterBtn');
  const filterModal = document.getElementById('filterModal');
  const cartToggleBtn = document.getElementById('cartToggleBtn');
  const drawerCartToggleBtn = document.getElementById('drawerCartToggleBtn');
  const closeCartBtn = document.getElementById('closeCartBtn');
  const cartDrawer = document.getElementById('cartDrawer');
  const closeProductDrawerBtn = document.getElementById('closeProductDrawerBtn');
  const productDrawer = document.getElementById('productDrawer');
  const scrollTopBtn = document.getElementById('scrollTopBtn');
  const closeZoomBtn = document.getElementById('closeZoomBtn');
  const imageZoomModal = document.getElementById('imageZoomModal');
  const zoomModalImg = document.getElementById('zoomModalImg');
  const zoomPrevImg = document.getElementById('zoomPrevImg');
  const zoomNextImg = document.getElementById('zoomNextImg');

  const faqToggleBtn = document.getElementById('faqToggleBtn');
  const closeFaqBtn = document.getElementById('closeFaqBtn');
  const faqModal = document.getElementById('faqModal');

  if (faqToggleBtn && faqModal) {
    faqToggleBtn.addEventListener('click', () => faqModal.classList.add('active'));
  }
  if (closeFaqBtn && faqModal) {
    closeFaqBtn.addEventListener('click', () => faqModal.classList.remove('active'));
  }
  if (faqModal) {
    faqModal.addEventListener('click', (e) => { if (e.target === faqModal) faqModal.classList.remove('active'); });
  }

  if (scrollTopBtn) {
    scrollTopBtn.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  if (themeToggleBtn) {
    themeToggleBtn.addEventListener('click', () => {
      const currentTheme = document.documentElement.getAttribute('data-theme');
      const nextTheme = currentTheme === 'dark' ? 'light' : 'dark';
      document.documentElement.setAttribute('data-theme', nextTheme);
    });
  }

  if (viewToggleBtn) {
    viewToggleBtn.addEventListener('click', () => {
      isZoomedOut = !isZoomedOut;
      viewToggleBtn.textContent = isZoomedOut ? 'VIEW -' : 'VIEW +';
      const catalogGrid = document.getElementById('catalogGrid');
      if (catalogGrid) catalogGrid.className = `catalog-grid ${isZoomedOut ? 'cols-8' : 'cols-4'}`;
    });
  }

  if (cartToggleBtn && cartDrawer) {
    cartToggleBtn.addEventListener('click', () => cartDrawer.classList.add('active'));
  }
  if (drawerCartToggleBtn && cartDrawer && productDrawer) {
    drawerCartToggleBtn.addEventListener('click', () => {
      productDrawer.classList.remove('active');
      cartDrawer.classList.add('active');
    });
  }
  if (closeCartBtn && cartDrawer) {
    closeCartBtn.addEventListener('click', () => cartDrawer.classList.remove('active'));
  }
  if (cartDrawer) {
    cartDrawer.addEventListener('click', (e) => { if (e.target === cartDrawer) cartDrawer.classList.remove('active'); });
  }

  if (closeProductDrawerBtn && productDrawer) {
    closeProductDrawerBtn.addEventListener('click', () => productDrawer.classList.remove('active'));
  }

  if (filterToggleBtn && filterModal) {
    filterToggleBtn.addEventListener('click', () => filterModal.classList.add('active'));
  }
  if (closeFilterBtn && filterModal) {
    closeFilterBtn.addEventListener('click', () => filterModal.classList.remove('active'));
  }
  if (filterModal) {
    filterModal.addEventListener('click', (e) => { if (e.target === filterModal) filterModal.classList.remove('active'); });
  }

  // CATEGORY FILTER CHIPS
  const categoryFilterGrid = document.getElementById('categoryFilterGrid');
  if (categoryFilterGrid) {
    categoryFilterGrid.addEventListener('click', (e) => {
      if (e.target.classList.contains('filter-btn-chip')) {
        document.querySelectorAll('#categoryFilterGrid .filter-btn-chip').forEach(b => b.classList.remove('active'));
        e.target.classList.add('active');
        categoryFilter = e.target.getAttribute('data-category');
      }
    });
  }

  // SIZE FILTER CHIPS
  const sizeFilterGrid = document.getElementById('sizeFilterGrid');
  if (sizeFilterGrid) {
    sizeFilterGrid.addEventListener('click', (e) => {
      if (e.target.classList.contains('filter-btn-chip')) {
        document.querySelectorAll('#sizeFilterGrid .filter-btn-chip').forEach(b => b.classList.remove('active'));
        e.target.classList.add('active');
        sizeFilter = e.target.getAttribute('data-size-filter');
      }
    });
  }

  // SORT ORDER CHIPS
  const sortFilterGrid = document.getElementById('sortFilterGrid');
  if (sortFilterGrid) {
    sortFilterGrid.addEventListener('click', (e) => {
      if (e.target.classList.contains('filter-btn-chip')) {
        document.querySelectorAll('#sortFilterGrid .filter-btn-chip').forEach(b => b.classList.remove('active'));
        e.target.classList.add('active');
        sortFilter = e.target.getAttribute('data-sort');
      }
    });
  }

  // STOCK FILTER CHIPS
  const stockFilterGrid = document.getElementById('stockFilterGrid');
  if (stockFilterGrid) {
    stockFilterGrid.addEventListener('click', (e) => {
      if (e.target.classList.contains('filter-btn-chip')) {
        document.querySelectorAll('#stockFilterGrid .filter-btn-chip').forEach(b => b.classList.remove('active'));
        e.target.classList.add('active');
        stockFilter = e.target.getAttribute('data-stock');
      }
    });
  }

  if (applyFilterBtn) {
    applyFilterBtn.addEventListener('click', () => {
      renderCatalog();
      if (filterModal) filterModal.classList.remove('active');
    });
  }

  if (resetFilterBtn) {
    resetFilterBtn.addEventListener('click', resetFilters);
  }

  // ZOOM MODAL LISTENERS
  if (closeZoomBtn && imageZoomModal) {
    closeZoomBtn.addEventListener('click', () => imageZoomModal.classList.remove('active'));
  }
  if (imageZoomModal) {
    imageZoomModal.addEventListener('click', (e) => {
      if (e.target === imageZoomModal || e.target === zoomModalImg) imageZoomModal.classList.remove('active');
    });
  }
  if (zoomPrevImg) {
    zoomPrevImg.addEventListener('click', (e) => {
      e.stopPropagation();
      if (currentZoomProduct && currentZoomProduct.images) {
        currentZoomImgIdx = (currentZoomImgIdx - 1 + currentZoomProduct.images.length) % currentZoomProduct.images.length;
        updateZoomImage();
      }
    });
  }
  if (zoomNextImg) {
    zoomNextImg.addEventListener('click', (e) => {
      e.stopPropagation();
      if (currentZoomProduct && currentZoomProduct.images) {
        currentZoomImgIdx = (currentZoomImgIdx + 1) % currentZoomProduct.images.length;
        updateZoomImage();
      }
    });
  }
}

function resetFilters() {
  categoryFilter = 'all';
  sizeFilter = 'all';
  stockFilter = 'all';
  sortFilter = 'default';

  document.querySelectorAll('#categoryFilterGrid .filter-btn-chip').forEach(b => b.classList.toggle('active', b.getAttribute('data-category') === 'all'));
  document.querySelectorAll('#sizeFilterGrid .filter-btn-chip').forEach(b => b.classList.toggle('active', b.getAttribute('data-size-filter') === 'all'));
  document.querySelectorAll('#sortFilterGrid .filter-btn-chip').forEach(b => b.classList.toggle('active', b.getAttribute('data-sort') === 'default'));
  document.querySelectorAll('#stockFilterGrid .filter-btn-chip').forEach(b => b.classList.toggle('active', b.getAttribute('data-stock') === 'all'));

  renderCatalog();
  const filterModal = document.getElementById('filterModal');
  if (filterModal) filterModal.classList.remove('active');
}

function openZoomModal(product, imgIndex = 0) {
  const imageZoomModal = document.getElementById('imageZoomModal');
  if (!imageZoomModal) return;
  currentZoomProduct = product;
  currentZoomImgIdx = imgIndex;
  updateZoomImage();
  imageZoomModal.classList.add('active');
}

function updateZoomImage() {
  const zoomModalImg = document.getElementById('zoomModalImg');
  const zoomPrevImg = document.getElementById('zoomPrevImg');
  const zoomNextImg = document.getElementById('zoomNextImg');

  if (!currentZoomProduct || !zoomModalImg) return;
  zoomModalImg.src = (currentZoomProduct.images && currentZoomProduct.images[currentZoomImgIdx]) ? currentZoomProduct.images[currentZoomImgIdx] : '';

  if (currentZoomProduct.images && currentZoomProduct.images.length > 1) {
    if (zoomPrevImg) zoomPrevImg.style.display = 'block';
    if (zoomNextImg) zoomNextImg.style.display = 'block';
  } else {
    if (zoomPrevImg) zoomPrevImg.style.display = 'none';
    if (zoomNextImg) zoomNextImg.style.display = 'none';
  }
}

/**
 * 6. ISOLATED & MODULAR ARCADE GAME ENGINE ("LOOSE SCREW")
 * -----------------------------------------------------------------------------
 * Encapsulated module for easy future updates or game mechanic swaps.
 */
const ArcadeGameEngine = {
  running: false,
  score: 0,
  highScore: 0,
  player: { x: 250, y: 340, w: 40, h: 12, speed: 6, dx: 0 },
  bullets: [],
  targets: [],
  gameLoop: null,
  spawnLoop: null,

  init() {
    const gameModalBtn = document.getElementById('gameModalBtn');
    const closeGameBtn = document.getElementById('closeGameBtn');
    const startGameBtn = document.getElementById('startGameBtn');
    const gameModal = document.getElementById('gameModal');

    if (gameModalBtn && gameModal) {
      gameModalBtn.addEventListener('click', () => gameModal.classList.add('active'));
    }
    if (closeGameBtn && gameModal) {
      closeGameBtn.addEventListener('click', () => {
        gameModal.classList.remove('active');
        this.stop();
      });
    }
    if (gameModal) {
      gameModal.addEventListener('click', (e) => {
        if (e.target === gameModal) {
          gameModal.classList.remove('active');
          this.stop();
        }
      });
    }
    if (startGameBtn) {
      startGameBtn.addEventListener('click', () => this.start());
    }

    document.addEventListener('keydown', (e) => {
      if (!this.running) return;
      if (e.key === 'ArrowLeft' || e.key === 'a' || e.key === 'A') this.player.dx = -this.player.speed;
      if (e.key === 'ArrowRight' || e.key === 'd' || e.key === 'D') this.player.dx = this.player.speed;
      if (e.key === ' ' || e.key === 'Spacebar') {
        this.bullets.push({ x: this.player.x + this.player.w / 2 - 2, y: this.player.y, w: 4, h: 8 });
      }
    });

    document.addEventListener('keyup', (e) => {
      if (['ArrowLeft','a','A','ArrowRight','d','D'].includes(e.key)) this.player.dx = 0;
    });
  },

  start() {
    this.stop();
    const gameCanvas = document.getElementById('gameCanvas');
    const gameScoreEl = document.getElementById('gameScore');
    if (!gameCanvas) return;

    this.score = 0;
    if (gameScoreEl) gameScoreEl.textContent = '000';
    this.player.x = (gameCanvas.width - this.player.w) / 2;
    this.bullets = [];
    this.targets = [];
    this.running = true;

    this.gameLoop = setInterval(() => this.update(), 1000 / 60);
    this.spawnLoop = setInterval(() => this.spawnTarget(), 800);
  },

  stop() {
    this.running = false;
    clearInterval(this.gameLoop);
    clearInterval(this.spawnLoop);
  },

  spawnTarget() {
    const gameCanvas = document.getElementById('gameCanvas');
    if (!gameCanvas) return;
    this.targets.push({
      x: Math.random() * (gameCanvas.width - 20),
      y: 0,
      w: 20,
      h: 20,
      speed: 1.5 + Math.random() * 2
    });
  },

  update() {
    const gameCanvas = document.getElementById('gameCanvas');
    const gameScoreEl = document.getElementById('gameScore');
    const gameHighScoreEl = document.getElementById('gameHighScore');
    if (!gameCanvas) return;

    this.player.x += this.player.dx;
    if (this.player.x < 0) this.player.x = 0;
    if (this.player.x + this.player.w > gameCanvas.width) this.player.x = gameCanvas.width - this.player.w;

    this.bullets.forEach((b, bi) => {
      b.y -= 7;
      if (b.y < 0) this.bullets.splice(bi, 1);
    });

    this.targets.forEach((t, ti) => {
      t.y += t.speed;
      if (t.y > gameCanvas.height) this.targets.splice(ti, 1);
    });

    this.bullets.forEach((b, bi) => {
      this.targets.forEach((t, ti) => {
        if (b.x < t.x + t.w && b.x + b.w > t.x && b.y < t.y + t.h && b.y + b.h > t.y) {
          this.bullets.splice(bi, 1);
          this.targets.splice(ti, 1);
          this.score += 10;
          if (gameScoreEl) gameScoreEl.textContent = String(this.score).padStart(3, '0');
          if (this.score > this.highScore) {
            this.highScore = this.score;
            if (gameHighScoreEl) gameHighScoreEl.textContent = String(this.highScore).padStart(3, '0');
          }
        }
      });
    });

    this.draw();
  },

  draw() {
    const gameCanvas = document.getElementById('gameCanvas');
    if (!gameCanvas) return;
    const ctx = gameCanvas.getContext('2d');

    ctx.clearRect(0, 0, gameCanvas.width, gameCanvas.height);

    ctx.fillStyle = '#fbf9ef';
    ctx.fillRect(this.player.x, this.player.y, this.player.w, this.player.h);

    ctx.fillStyle = '#ef4444';
    this.bullets.forEach(b => ctx.fillRect(b.x, b.y, b.w, b.h));

    ctx.fillStyle = '#a3a3a3';
    this.targets.forEach(t => {
      ctx.beginPath();
      ctx.arc(t.x + t.w / 2, t.y + t.h / 2, t.w / 2, 0, Math.PI * 2);
      ctx.fill();
    });
  }
};

// Initialize Arcade Engine
document.addEventListener('DOMContentLoaded', () => {
  ArcadeGameEngine.init();
});
